import {useState} from 'react';
import {toast} from 'react-toastify';
import  Imagem  from '../../asset/LogoPF.png' ;
import api from '../../service/index'
import './email.css';

export default function App() {
   const [email, setEmail] = useState('')
   const [codigo, setCodigo]= useState('')
 

   async function handleEnviar(){
          
    var pass = '';
    var str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 
                    'abcdefghijklmnopqrstuvwxyz0123456789@#$';
     var  i='';          
            for (i = 1; i <= 8; i++) {
                var char = Math.floor(Math.random()
                            * str.length + 1);
                  
                pass += str.charAt(char)
            }
              
          ///  console.log(pass);

    if(email === ''){
      toast.info("Prencha o Email")
      return
    }
    try{
      const response = await api.post(`api/forgot/${email}/${pass}`);
      ///console.log(response.data)
      setCodigo(response.data)
      toast.info(response.data.message)
      setEmail("")
    }catch{
      setEmail("")
    }
  }

  return (
   <div className="Conteiner">
      <img src={Imagem} alt="Logo Passe Facil"/>
      <div className='Item'>
    <div className='Informacao'>
      <h1>Esqueceu a senha?</h1>
        <p>
        Para recuperar o seu acesso, preencha<br/>o campo com o email cadastrado
        </p>
     </div>
     <input
          type='email'
          placeholder="Digite o email"
          value={email}
          onChange={(e)=>setEmail(e.target.value)}/>
     <button onClick={handleEnviar} className="btn">Enviar</button>
        <h5>Caso não tenha acesso ao e-mail <br/>cadastrado, entre em contato com o <br/>nosso Call center 3201-0101</h5>
     </div>
    </div>
     );
}
